import $ from 'jquery';
// Comment input: set .completed if textare filled
$(".comment-input").each((i, element) => checkState(element))

$(".comment-input").on("input", "textarea", function () {
    checkState(this);
});

function checkState(element: HTMLTextAreaElement) {
    const container = element.closest(".comment-input");
    container.classList.toggle("completed", !!element.value);
}
export default undefined;